<template>
	<CCard>
		<CCardHeader>
			<strong>Revenue Report</strong>
		</CCardHeader>
		<CCardBody>
			<CRow>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Start Date</label>
                  <input
                      type="date"
                      placeholder="Start Date"
                      class="form-control"
                      v-model="startDate"
                  />
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">End Date</label>
                  <input
                      type="date"
                      placeholder="End Date"
                      class="form-control"
                      v-model="endDate"
                  />
                </div>
              </CCol>
			  <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">User Type</label>
                  <v-select
                      :options="userTypeOptions"
					  @option:selected="userlist"
                      v-model="userType"
                  ></v-select>
                </div>
              </CCol>
			  <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">User</label>
                  <v-select
                      :options="usersOptions"
                      v-model="user"
                  ></v-select>
                </div>
              </CCol>
			  <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Transaction Type</label>
                  <v-select
                      :options="paymentOptions"
                      v-model="payment"
                  ></v-select>
                </div>
              </CCol>
			  <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Payment Method</label>
                  <v-select
                      :options="paymentMethodOptions"
                      v-model="paymentMethod"
                  ></v-select>
                </div>
              </CCol>
			  <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Module Type</label>
                  <v-select
                      :options="moduleTypeOptions"
                      v-model="moduleType"
                  ></v-select>
                </div>
              </CCol>
			  <CCol sm="3">
                <div class="form-group" style="margin-top: 30px">
                  <CButton
                      type="submit"
                      size="sm"
                      color="primary"
                      @click="applyFilter()"
                      v-c-tooltip="$lang.common.filter.button.filter"
                  >
                    {{ $lang.common.filter.button.filter }}
                  </CButton>
                  &nbsp;
                  <CButton
                      color="danger"
                      size="sm"
                      @click="resetFilter()"
                      v-c-tooltip="$lang.common.filter.button.cancel"
                  >
                    {{ $lang.common.filter.button.cancel }}
                  </CButton>
                </div>
              </CCol>
			</CRow>
			<hr>
			<div id="chart">
				<apexchart type="pie" height="350" :options="chartOptions" :series="series"></apexchart>
			</div>
			<hr>
			<v-server-table
				:columns="columns"
				url="/reports/revenue/report/list"
				:options="options"
				ref="myTable"
			>
			</v-server-table>
		</CCardBody>
	</CCard>
</template>

<script>
import Vue from "vue";
import { ServerTable } from "vue-tables-2";
import store from "../../store/store";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { Mixin } from "/src/mixins/index.js";
import apexchart from "vue-apexcharts";

Vue.use(ServerTable, {}, false);

export default {
	name: "RevenueReport",
	mixins: [Mixin],
	components: {
		apexchart,
		DateRangePicker
	},
	data() {
		return {
			module:"",
			userType:"",
			payment:"",
			user:"",
			usersOptions:[],
			moduleType:"",
			paymentMethod:"",
			userTypeOptions: [
				{
					"value":"DirectCandidate",
					"label":"Direct Candidate",
				},
				{
					"value":"User",
					"label":"User",
				}
			],
			moduleTypeOptions: [
				{
					"value":"PlantDream",
					"label":"Plant Dream",
				},
				{
					"value":"MentoringMind",
					"label":"Mentoring Mind",
				},
				{
					"value":"ExternalInterview",
					"label":"External Interview",
				},
				{
					"value":"CorporateCoach",
					"label":"Corporate Coach",
				},
				{
					"value":"DirectCandidateAIResume",
					"label":"Direct Candidate AI Resume",
				},
				{
					"value":"ResumeTemplate",
					"label":"Resume Template",
				},
				{
					"value":"DonateMoney",
					"label":"Donate Money",
				},
				{
					"value":"AutoAIInterview",
					"label":"Auto AI Interview",
				},
				{
					"value":"AlumniMembershipFee",
					"label":"Alumni Membership Fee",
				},
				{
					"value":"AIInterview",
					"label":"AI Interview",
				},
				{
					"value":"AddPointToWallet",
					"label":"Add Point To Wallet",
				},
				{
					"value":"TrialPoints",
					"label":"Trial Points",
				},
				{
					"value":"Withdrawal",
					"label":"Withdrawal",
				}
			],
			paymentOptions: [
				{
					"value":"Credit",
					"label":"Credit",
				},
				{
					"value":"Debit",
					"label":"Debit",
				},
				{
					"value":"Freeze",
					"label":"Freeze",
				}
			],
			paymentMethodOptions: [
				{
					"value":"Wallet",
					"label":"Wallet",
				},
				{
					"value":"Razorpay",
					"label":"Razorpay",
				}
			],
			startDate:"",
			endDate:"",
			direction: 'ltr',
			self: this,
			series: [],
			columns: ["createdName","userType","transactionDate","points","transactionFee","gst",'transactionType','transactionId',"paymentMethod","description","entityType"],
			options: {
				headings: {
					createdName : "User Name",
					userType:"User Type",
					transactionDate : "Date & Time",
					points : "Points",
					transactionFee : "Transaction Fee",
					gst : "GST",
					description : "Description",
					transactionType : 'Transaction Type',
					transactionId: 'Transaction Id',
					paymentMethod : 'Payment Method',
					entityType : 'Use For',
				},
				editableColumns: ["createdName",'transactionType','transactionId',"paymentMethod","userType","transactionDate","points","transactionFee","gst","description","entityType"],
				sortable: [],
				filterable: ["createdName",'transactionType','transactionId',"paymentMethod","userType","transactionDate","points","transactionFee","gst","description","entityType"],
			},
			chartOptions: {
				chart: {
					type: 'pie',
					height: 350,
				},
				labels: [
					'Total',
					'GST', 
					'Platform', 
					// 'Plant Dream',
					// 'Mentoring Mind', 
					// 'External Interview', 
					// 'Corporate Coach',
					// 'Direct Candidate AI Resume', 
					// 'Resume Template', 
					// 'Donate Money',
					// 'Auto AI Interview',
					// 'Alumni Membership Fee',
					// 'AI Interview',
					// 'Add Point To Wallet',
					// 'Trial Points',
					// 'Withdrawal',
				],
				legend: {
					position: 'left'
				}
			},
		};
	},
	mounted() {
		let self = this;
		axios
          .post('reports/revenue/report')
          .then(function (response) {
            if (response) {
              	self.series = response.data.data;
            } else {
				self.series = [];
            }
          });
		store.commit("showLoader", false);
	},
	methods : {
		userlist(type){
			let self = this;
			const reqObj = {
				userType: type.value,
			};
			axios
				.post('reports/revenue/user-list',reqObj)
				.then(function (response) {
					if (response) {
						self.usersOptions = response.data.data;
					}
				});
		},	
		applyFilter() {
			store.commit("showLoader", true);
			let self = this;
			let userType = "";
			let payment = "";
			let moduleType = "";
			let user = "";
			let paymentMethod = "";
			if (self.userType.value != null) {
				userType = this.userType.value;
			}
			if (self.payment.value != null) {
				payment = this.payment.value;
			}
			if (self.moduleType.value != null) {
				moduleType = this.moduleType.value;
			}
			if (self.user.value != null) {
				user = this.user.value;
			}
			if (self.paymentMethod.value != null) {
				paymentMethod = this.paymentMethod.value;
			}
			const reqObj = {
				fromDate: self.startDate,
				toDate: self.endDate,
				userType: userType,
				payment: payment,
				user: user,
				moduleType: moduleType,
				paymentMethod: paymentMethod
			};
			this.$refs.myTable.customQueries = reqObj;
			this.$refs.myTable.refresh();
			axios
				.post('reports/revenue/report',reqObj)
				.then(function (response) {
					if (response) {
						self.series = response.data.data;
					} else {
						self.series = [];
					}
					store.commit("showLoader", false);
				});
		},
		resetFilter() {
			store.commit("showLoader", true);
			this.startDate = "";
			this.endDate = "";
			this.userType = "",
			this.payment = "",
			this.user = "",
			this.moduleType = "",
			this.paymentMethod = "",
			this.$refs.myTable.customQueries = {};
			this.$refs.myTable.refresh();
			axios
				.post('reports/revenue/report')
				.then(function (response) {
					if (response) {
						self.series = response.data.data;
					} else {
						self.series = [];
					}
					store.commit("showLoader", false);
				});
		},
	}
};
</script>

<style>
div .error {
	color: red;
}

.hasError label {
	color: red;
}
</style>